import { createFileRoute } from '@tanstack/react-router';
import { assertDealLedgerEnabled } from '../-utils/assertDealLedgerEnabled';
export const Route = createFileRoute('/_staff/deal/add/')({
  beforeLoad: assertDealLedgerEnabled,
  component: () => null
});